// Single source of truth for "is this user an admin?".
// The actual security boundary is the SQL policy defined in
// supabase/migrations/20260718000000_p0_role_rls_admin_seed.sql:
//     USING (
//       (SELECT role FROM public.profiles
//        WHERE id = (select auth.uid())) = 'admin'
//     )
//
// Everything in this file is pure UX (button gating, toasts). The DB is
// always the final word - if you bypass this helper, the policy still gates.

import { supabase } from '../supabase';

export const PLATFORM_ADMIN_EMAIL = 'chimske@gmail.com';

/**
 * isPlatformAdmin - confirms admin status by reading the profiles.role
 * column rather than trusting client-side tokens or the (mutable) user
 * email. Single round-trip; safe to spam from render paths.
 *
 * Returns false if the user is unauthenticated, if the role lookup fails,
 * or if profiles.role !== 'admin'.
 */
export async function isPlatformAdmin(
  user: { id?: string; email?: string } | null | undefined,
): Promise<boolean> {
  if (!user?.id) return false;
  const { data, error } = await supabase
    .from('profiles')
    .select('role')
    .eq('id', user.id)
    .single();
  if (error || !data) return false;
  return (data as { role?: string }).role === 'admin';
}

/**
 * hasAdminRole - synchronous utility for the many places we already
 * have a profile object in React state (after the bootstrap effect has
 * run). Use this in render paths to avoid a round-trip per re-render.
 */
export function hasAdminRole(
  profile: { role?: string } | null | undefined,
): boolean {
  return profile?.role === 'admin';
}
